import * as React from 'react';
import Menu from '@mui/material/Menu';
import { Formik, Form } from 'formik';
import { IconButton, TextField, Typography, Button, Stack, Box, MenuItem } from '@mui/material';
import Iconify from './Iconify';

const Filter = ({ toggleFilter, applyFilters }) => {
  const [anchorEl, setAnchorEl] = React.useState(null);

  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <div>
        <Box style={{ display: 'flex', justifyContent: 'end' }}>
          <IconButton onClick={handleClick}>
            <Iconify icon="ic:round-filter-list" />
            <Typography variant="h6"> Filter</Typography>
          </IconButton>

          <Menu
            id="basic-menu"
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
            MenuListProps={{
              'aria-labelledby': 'basic-button',
            }}
          >
            <Formik
              initialValues={{
                // id: '',
                // name: '',
                isBlocked: '',
              }}
              onSubmit={async (values) => {
                applyFilters(values);
              }}
            >
              {({ values, errors, touched, handleChange, handleBlur, handleSubmit, isSubmitting }) => (
                <Form style={{ padding: '10px' }}>
                  <Stack direction="column" spacing={1} sx={{ width: '250px' }}>
                    {/* <Stack direction="row" spacing={1}> */}
                    {/* <TextField
                        style={{ paddingBottom: '10px' }}
                        id="id"
                        name="id"
                        label="Country ID"
                        value={values.id}
                        onChange={handleChange}
                      /> */}
                    {/* <TextField
                        id="name"
                        name="name"
                        fullWidth
                        label="Country Name"
                        value={values.name}
                        onChange={handleChange}
                      /> */}
                    {/* </Stack> */}
                    <Stack direction="row" spacing={1}>
                      <TextField
                        select
                        fullWidth
                        id="isBlocked"
                        name="isBlocked"
                        label="Status"
                        value={values.isBlocked}
                        onChange={handleChange}
                      >
                        <MenuItem value="true">Blocked</MenuItem>
                        <MenuItem value="false">Active</MenuItem>
                      </TextField>
                    </Stack>
                    <Button variant="contained" type="submit" style={{ marginTop: '10px' }}>
                      Filter
                    </Button>
                  </Stack>
                </Form>
              )}
            </Formik>
          </Menu>
        </Box>
      </div>
    </>
  );
};

export default Filter;
